<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.9878 38.3915C40.0393 38.7986 39.9131 39.2081 39.6426 39.5157C39.3712 39.8233 38.9803 40 38.5703 40H5.71383C5.17955 40 4.69004 39.7024 4.44481 39.2272C4.1991 38.7529 4.2391 38.181 4.54814 37.7448C7.42284 33.6911 15.2089 31.4945 21.384 30.5554C21.2706 27.0365 20.8397 23.218 19.175 20.0219C14.9189 20.3757 10.7209 24.4199 8.32425 27.946C7.96759 28.4707 7.30951 28.6979 6.70381 28.5026C6.10049 28.3079 5.69716 27.7388 5.71478 27.1041C5.81859 23.2642 6.55619 18.2281 11.0175 15.0077C7.61141 14.931 3.49388 15.4086 1.64963 15.6977C1.11107 15.7829 0.571083 15.5534 0.258709 15.1067C-0.0536655 14.6601 -0.0860455 14.0748 0.177282 13.5982C3.37578 7.78451 10.3899 5.70503 17.8936 8.22973C22.5573 0.387999 33.7523 0.0141975 34.2489 0.00134067C34.9027 -0.0286587 35.5232 0.447998 35.676 1.10989C35.8279 1.77178 35.4932 2.44891 34.8746 2.73033C34.7918 2.76795 27.7153 6.03121 25.1363 10.6297C30.6423 9.60828 37.7788 11.8111 39.7755 14.9472C40.0355 15.3567 40.0707 15.8705 39.8683 16.3115C39.6655 16.7524 39.2526 17.06 38.7726 17.1281C33.5266 17.8781 29.4528 18.6305 26.6181 19.3743C27.3853 20.5014 28.0638 21.669 28.7033 22.857H26.6829C25.8939 22.857 25.2544 23.4965 25.2544 24.2856C25.2544 25.0746 25.8939 25.7141 26.6829 25.7141H30.0957C30.7666 27.2412 31.3723 28.8079 31.8733 30.4488C36.4332 31.5121 39.4788 34.3792 39.9878 38.3915Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "CategoryDestinationIsland"
};
</script>
